import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect, useState } from 'react';
import { AudioAtom } from '@guardian/atoms-rendering';
import { onConsentChange, getConsentFor, } from '@guardian/consent-management-platform';
export const AudioAtomWrapper = ({ id, trackUrl, kicker, title, pillar, duration, contentIsNotSensitive, aCastisEnabled, readerCanBeShownAds, }) => {
    // *****************
    // *     ACast     *
    // *****************
    const [shouldUseAcast, setShouldUseAcast] = useState(false);
    useEffect(() => {
        onConsentChange((state) => {
            // Should we use ad enabled audio? If so, then set the shouldUseAcast
            // state to true, triggering a rerender of AudioAtom using a new track url
            // (one with adverts)
            const consentGiven = getConsentFor('acast', state);
            if (aCastisEnabled &&
                consentGiven &&
                readerCanBeShownAds && // Eg. Not a subscriber
                contentIsNotSensitive) {
                setShouldUseAcast(true);
            }
        });
    }, [contentIsNotSensitive, aCastisEnabled, readerCanBeShownAds]);
    return (_jsx(AudioAtom, { id: id, trackUrl: trackUrl, kicker: kicker, title: title, pillar: pillar, duration: duration, shouldUseAcast: shouldUseAcast }, void 0));
};
